import './App.css';
import Home from './Page/Home';

function App() {
  return (
    <div className="App">
      <Home/>     
    </div>
  );
}

export default App;
